<template>
    <div>
        <div class="px-5 py-2 md:px-10 md:py-20">
            <div class="flex items-center justify-center h-full overflow-y-auto">
                <div class="w-full md:w-3/4 xl:w-1/2">
                    <div class="hidden md:block mb-5">
                        <div class="flex justify-between">
                            <h1 class="font-hairline lowercase">{{ $t('schedules') }}</h1>

                            <button class="btn text-right w-1/2"
                                    @click="add()">
                                <icon icon="plus"></icon> {{ $t('new_schedule') }}
                            </button>
                        </div>
                    </div>

                    <div class="text-center" v-if="schedules.length">
                        {{ usage.usage }} / {{ usage.of }}
                    </div>

                    <div v-if="loading" class="flex items-center justify-center p-20">
                        <div class="loader"></div>
                    </div>

                    <div v-if="!loading">
                        <div class="grid w-full grid-cols-1">
                            <div v-if="!schedules.length && !loading" class="text-center pt-24">
                                <h1 class="text-white opacity-25">
                                    {{ $t('no_schedules_created') }}
                                </h1>
                            </div>

                            <div v-for="(schedule, k) in schedules"
                                 @click="view(schedule)"
                                 class="bg-white text-gray-700 p-5 my-4 rounded chat" :key="k">

                                <div class="flex items-center">
                                    <div class="w-auto justify-center">
                                        <img class="w-10 h-10 rounded-full mr-5 mb-2" :src="schedule.instance.image">

                                        <div class="md:hidden text-sm">
                                            {{ schedule.week_day_short }} <br>
                                            {{ schedule.day_time }}
                                        </div>
                                    </div>

                                    <div class="text-sm w-4/5">
                                        <p class="text-gray-900 leading-none mb-1">{{ schedule.instance.name }}</p>

                                        <p class="text-gray-600" v-for="(action, k) in schedule.actions" :key="k">
                                            - {{ action.name }}
                                        </p>

                                        <div v-if="schedule.one_time_execution" class="mt-2">
                                            <div class="p-1 px-2 rounded text-white bg-yellow-400">
                                                {{ $t('this_schedule_will_be_removed_after_execution') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="hidden md:block text-right w-1/5 text-sm">
                                        {{ schedule.week_day_full }} <br>
                                        {{ schedule.day_time }}
                                    </div>
                                </div>
                            </div>

                            <div v-if="pagination.current_page < pagination.last_page">
                                <button class="btn" :disabled="processing" @click="loadMore()">load more</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Zapin } from "@/services/Api";

    export default {

        mounted() {
            this.loadSchedules();
            this.loadUsage();
        },

        data() {
            return {
                loading: false,
                schedules: [],
                pagination: {
                    current_page: 0,
                    last_page: 1
                },
                processing: false,
                usage: {
                    usage: null,
                    of: null
                }
            }
        },

        methods: {
            loadMore() {
                if(this.pagination.current_page < this.pagination.last_page) {
                    this.loadSchedules();
                }
            },

            loadUsage() {
                Zapin.subscription()
                    .schedulesUsage()
                    .then(res => {
                        this.usage = res.data.schedules_usage;
                    })
            },

            loadSchedules() {
                if(this.pagination.current_page === 0) {
                    this.loading = true;
                }

                this.processing = true;
                this.pagination.current_page++;

                Zapin
                    .schedules()
                    .paginate(this.pagination.current_page)
                    .then(res => {
                        this.pagination.last_page = res.meta.last_page;
                        this.schedules = this.schedules.concat(res.data);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.processing = false;
                    })
            },
            add() {
                this.$router.push({
                    name: 'NewSchedule'
                });
            },

            view(schedule) {
                this.$router.push({
                    name: 'ViewSchedule',
                    params: {
                        id: schedule.id
                    }
                });
            }
        }
    }
</script>